import React, { useState} from 'react';
import cssClasses from "./admicard.module.css";

//*files
import HallTicketPDF from "../HallTicketPDF/HallTicketPDF";

//*MUI
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
    ...theme.typography.body2,
    color: theme.palette.text.secondary,
  }));

export default function AdmitCard({examObject}) {
    const [selectedHallTicketForDownload, setSelectedHallTicketForDownload] = useState(null)


  return (<>
    <Grid style={{width: '30rem' , margin:'1rem 4rem' }}  >
            <Item>
                <div className={cssClasses.examCard}>
                    <div className={cssClasses.examCardFirstRow}>
                        <div className={cssClasses.paddingDiv}>
                            <div className={cssClasses.imageWrapper}>
                                <div className={cssClasses.imageSection}>
                                    <img src={examObject?.image} alt="ExamLogo" />
                                </div>
                                <div className={cssClasses.StatusDiv}>
                                  {
                                    examObject?.hallTicketStatus === "published" && 
                                    <button className={cssClasses.DownloadDiv} 
                                        onClick={() => {setSelectedHallTicketForDownload({...examObject.hallTicketDetails})}}>Download Now</button>
                                  }
                                </div>
                            </div>
                            <div className={cssClasses.nameWrapper}>
                                <p className={cssClasses.examName}>{examObject?.name}</p>
                                <p className={cssClasses.label}>{examObject?.examShortName}</p>
                            </div>
                        </div>
                    </div>
                    <div className={cssClasses.paddingDiv}>
                        <div className={cssClasses.info}>
                            <div className={cssClasses.examDetailsWrapper}>
                                <p className={cssClasses.inputLabel}>Exam Fee</p>
                                <p className={cssClasses.inputValue}>₹ {examObject?.fee}</p>
                            </div>
                            <div className={cssClasses.examDetailsWrapper}>
                                <p className={cssClasses.inputLabel}>Exam Date</p>
                                <p className={cssClasses.inputValue}>{examObject?.examDate}</p>
                            </div>
                            <div className={cssClasses.examDetailsWrapper}>
                                <p className={cssClasses.inputLabel}>Payment type</p>
                                <p className={cssClasses.inputValue}>{examObject?.paymentType === "Both" ? "Online/Offline" : examObject?.paymentType}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </Item>

              
          </Grid>
          { selectedHallTicketForDownload && 
            <HallTicketPDF 
                hallTicket={selectedHallTicketForDownload}
                setObject={() => {setSelectedHallTicketForDownload(null)}}
            /> 
           }
          </>
  )
}
